module.exports = __webpack_public_path__ + "img/dashboard.dbd19006.svg";